"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestGen2 = requestGen2;
exports.request = request;
const GraphQL = __importStar(require("graphql"));
const GraphQLRequest = __importStar(require("graphql-request"));
async function requestGen2(graphqlEndpoint, query, variables, includeServerLog, authorization, _sha256) {
    const minimizedQuery = GraphQL.print(query).replace(/\s+/g, " ");
    if (!minimizedQuery) {
        throw new Error("Could not get query string.");
    }
    const defaultHeaders = Object.assign(Object.assign({}, (authorization.type === "bearer"
        ? { Authorization: `Bearer ${authorization.accessToken}` }
        // Cookie-authenticated /graphql requests are CSRF-checked server-side for this
        // exact header (CsrfProtectionMiddleware) - a cross-site form/script can't set it.
        : { "X-Genesys-Requested-With": "fetch" })), (includeServerLog
        ? {
            "include-server-log": "true"
        }
        : {}));
    const client = new GraphQLRequest.GraphQLClient(graphqlEndpoint, {
        credentials: authorization.type === "cookies" ? "include" : "omit",
        headers: defaultHeaders
    });
    const response = await client.rawRequest(minimizedQuery, variables);
    const data = response.data;
    const headers = response.headers;
    const extensions = response.extensions;
    if (extensions) {
        if (extensions.log) {
            setImmediate(() => log(extensions.log));
        }
        const timerLog = headers.get("X-TIMER");
        if (timerLog) {
            setImmediate(() => {
                for (const row of timerLog.split("@@@")) {
                    console.log(row);
                }
            });
        }
        if (extensions.traceId &&
            minimizedQuery.indexOf("UpdateSystemStatus") > -1) {
            setImmediate(() => {
                console.log("CalculationLogs: " +
                    `${window.location.origin}/log-viewer/${extensions.traceId}`);
            });
        }
    }
    return data;
    // }
}
/**
 * This is just a proxy for the request function in the graphql-request package
 * with the added feature that you can also send an AST instead of a string.
 */
async function request(query, variables, includeServerLog, endpoint, authorization) {
    // If it is not a string, then get the string from the AST
    const queryString = typeof query === "string" ? query : GraphQL.print(query);
    if (!queryString) {
        throw new Error("Could not get query string.");
    }
    const client = new GraphQLRequest.GraphQLClient(endpoint, {
        credentials: authorization.type === "cookies" ? "include" : "omit",
        headers: Object.assign(Object.assign({}, (authorization.type === "bearer"
            ? { Authorization: `Bearer ${authorization.accessToken}` }
            // Cookie-authenticated /graphql requests are CSRF-checked server-side for this
            // exact header (CsrfProtectionMiddleware) - a cross-site form/script can't set it.
            : { "X-Genesys-Requested-With": "fetch" })), (includeServerLog
            ? {
                "include-server-log": "true"
            }
            : {}))
    });
    const response = await client.rawRequest(queryString, variables || {});
    const data = response.data;
    const extensions = response.extensions;
    if (extensions && extensions.log) {
        setImmediate(() => log(extensions.log));
    }
    return data;
}
function log(rows) {
    // Severity: 0 = Info, Below 100 = Warning, Above 100 = Error.
    for (const row of rows) {
        const [severity, category, message] = row.split("@@@");
        const formattedMessage = `[${category}]: ${message}`;
        const severityParsed = parseInt(severity, 10);
        // Only use console.error for messages from Genesys namespaces
        // We don't have control over EventIds in external libraries
        if (!category.startsWith("Genesys")) {
            console.info(formattedMessage);
            continue;
        }
        if (severityParsed <= 100) {
            console.info(formattedMessage);
        }
        else {
            console.error(formattedMessage);
        }
    }
}
//# sourceMappingURL=index.js.map